/**
 * Given a list of predicates and a single value, check if the value passes all predicates (Array.every)
 *
 * @example
 *  const predicates = [ isNotEmpty, isNotNil, isNotNaN ]
 *  const model = {...}
 *  const hasModel = allPass(predicates)(model)
 *  // -> true
 */
export const allPass = (predicateList) => (value) =>
    predicateList.every((predicate) => Boolean(predicate(value)));
